<template>
  <div class="grid size-full">
    <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
      <button
        type="button"
        class="rounded-md bg-white text-font hover:text-font-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        @click="close">
        <span class="sr-only">Close</span>
        <!-- Heroicon name: outline/x -->
        <svg
          class="size-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div class="flex flex-col items-center justify-center p-4">
      <h1 class="mt-3 text-xl font-medium text-gray-900">
        Please confirm to delete!
      </h1>
      <p class="mt-2 text-center text-danger">
        Be wary &ndash; this action will delete this project and all proposals attached. There is no going back.
      </p>
      <p class="my-2 text-center text-sm text-font">
        Note that you can also delete or hide single proposals.
      </p>
    </div>
    <div class="m-2 flex">
      <button
        type="button"
        class="inline-flex w-3/4 justify-center rounded-md border border-transparent bg-danger
          px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-danger-dark
          focus:outline-none focus:ring-2 focus:ring-danger focus:ring-offset-2  sm:text-sm"
        @click="deleteProject">
        Delete
      </button>
      <button
        type="button"
        class="ml-3 inline-flex w-1/4 justify-center rounded-md border border-warning bg-warning
          px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-warning-dark
          focus:outline-none focus:ring-2 focus:ring-danger  focus:ring-offset-2 sm:text-sm"
        @click="close">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DeleteConfirmation',
  props: {
    project: Object,
  },

  data() {
    return {
    };
  },

  methods: {
    close() {
      this.$emit('close');
    },

    deleteProject() {
      this.editing = false;
      this.$inertia.delete(route('projects.delete', { project: this.project.id }), {
        onSuccess: () => {
          this.$notify({
            type: 'info',
            title: 'Deleted',
            text: 'The project was deleted',
          }, 4000);
        },
        onError: () => {
          this.$notify({
            type: 'danger',
            title: 'Something went wrong',
            text: 'Could not delete the project',
          }, 4000);
        },
      });
    },

  },
};
</script>
